export const environment = {
  production: false,
  apiUrl: 'https://api.redelivery.dev.k8s.redj.ar',
  // apiUrl: 'https://localhost:5001',
  primaryColorHex: '#f1c30f',
};
